<template>
  <div class="VbSwitchWithTwoLabels is-inline-block">
    <span v-on:click="setValue(false)" :class="!checked ? 'active' : ''">{{labelLeft}}</span>
    <vb-switch type="" size="medium" v-model="checked"/>
    <span v-on:click="setValue(true)" :class="checked ? 'active' : ''">{{labelRight}}</span>
  </div>
</template>

<script>
    import VbSwitch from 'vue-bulma-switch'

    export default {
        name: 'VbSwitchWithTwoLabels',
        components: {
          VbSwitch
        },
        props: ['model', 'labelLeft', 'labelRight', 'onchange'],
        data() {
          return {
            checked: true
          }
        },
        mounted() {
          this.checked = this._props.model
        },
        methods: {
          setValue(val) {
            if (this.checked !== val) {
              this.$el.querySelector('.switch').click()
            }
            if (this._props.onchange) {
              this._props.onchange(val)
            }
          }
        },
        watch: {
          model(v) {
            this.setValue(v)
          }
        }
      }
</script>

<style scoped>
 span.active {
   font-weight: bold;
 }
  span {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// VbSwitchWithTwoLabels.vue?0b7db4e0